"use client";

import { ComponentProps } from "react";

import StarIcon from "@repo/ui-system/icons/rating/star/outline.svg";

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";

import { QuickPicksContent } from "./quick-picks-content";

type BestQuickPicks = ComponentProps<
  typeof QuickPicksContent
>["quickPicksItems"];

type Props = {
  quickPicksItems: BestQuickPicks;
  className?: string;
};

export function QuickPicks({ quickPicksItems, className }: Props) {
  return (
    <NavigationMenu
      viewport={false}
      className={cn("max-w-none", className)}
    >
      <NavigationMenuList className="gap-0">
        <NavigationMenuItem value="quick-picks">
          <NavigationMenuTrigger className="h-8 gap-1.5 border border-[#C1C5D3] mini1 text-[#4B5665] lg:hover:border-[#A3A9BE] px-3 shadow-none hover:bg-transparent! data-[state=open]:bg-transparent data-[state=open]:shadow-none">
            <StarIcon className="size-4" />
            <span>Quick Picks</span>
          </NavigationMenuTrigger>

          <NavigationMenuContent className="fixed! top-(--header-height)! left-0 right-0 w-page-width! mx-auto rounded-xl border-0! bg-transparent shadow-none px-4 pt-4 pb-4 data-[motion^=from-]:animate-none! data-[motion^=to-]:animate-none! data-[state=open]:animate-none data-[state=closed]:animate-none">
            <QuickPicksContent quickPicksItems={quickPicksItems} />
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
